import { useEffect, useState } from "react";
import FileUploadField from "../../shared/form/fields/FileUploadField";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFiles, faImage } from "@fortawesome/pro-regular-svg-icons";
import { map } from "lodash";

interface AttachmentsTypes {
  selectedTab?: string;
  filesCount?: number;
  imagesCount?: number;
}

export default function Attachments({
  filesCount,
  imagesCount,
  selectedTab = "",
}: AttachmentsTypes) {
  const [openTab, setOpenTab] = useState(selectedTab);

  // To react to external isOpen prop changes
  useEffect(() => setOpenTab(selectedTab), [selectedTab]);

  return (
    <div className="mt-2 flex flex-col gap-2">
      <div className="flex space-x-2">
        {map(["files", "images"], (tab: "files" | "images") => {
          const BADGE_LOOKUP = { files: filesCount, images: imagesCount };

          return (
            <button
              key={tab}
              className="stack-container btn btn-sm btn-light items-center justify-center w-[32px] h-[32px]"
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(tab);
              }}
            >
              <FontAwesomeIcon
                className="stack-item"
                icon={{ files: faFiles, images: faImage }[tab]}
              />
              {(BADGE_LOOKUP[tab] as number) > 0 && (
                <span className="stack-item badge rounded-xl bg-unread self-start justify-self-end -mr-3! -mt-2.5!">
                  {BADGE_LOOKUP[tab]}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {openTab == "files" && (
        <FileUploadField
          name="files"
          options={{ multiple: true, selectExisting: true }}
        />
      )}
      {openTab == "images" && (
        <FileUploadField
          name="images"
          options={{
            multiple: true,
            isImage: true,
            storageDirectory: "images",
          }}
        />
      )}
    </div>
  );
}
